var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',_vm._l((_vm.columnData),function(item){return _c('li',{key:item.field},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.data[item.field] || "-"))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }